import { usePublicSettings } from '../settings/queries';

export enum FeatureFlag {
  DISABLE_ROLES_SYNC = 'disable-roles-sync',
  DISABLE_EXTERNAL_REQUESTS = 'disable-external-requests',
  AUTO_PATCH = 'auto-patch',
}

export function useFeatureFlag(
  flag: FeatureFlag,
  {
    onSuccess,
    enabled = true,
  }: { onSuccess?: (isEnabled: boolean) => void; enabled?: boolean } = {}
) {
  return usePublicSettings<boolean>({
    select: (settings) => settings.Features[flag],
    onSuccess,
    enabled,
  });
}
